/* Vitday theme — interactivity */
(function(){
  var header = document.querySelector('.vd-header');
  if (header) {
    var onScroll = function(){ header.classList.toggle('is-scrolled', window.scrollY > 10); };
    window.addEventListener('scroll', onScroll, { passive:true });
    onScroll();
  }
  document.querySelectorAll('.vd-faq-item').forEach(function(item){
    var q = item.querySelector('.vd-faq-q');
    if (!q) return;
    q.addEventListener('click', function(){
      var open = item.classList.contains('is-open');
      item.parentNode.querySelectorAll('.vd-faq-item').forEach(function(s){ s.classList.remove('is-open'); });
      if (!open) item.classList.add('is-open');
    });
  });
  var pills = document.querySelectorAll('.vd-quiz-card .vd-pill');
  var heroCta = document.querySelector('.vd-quiz-card .vd-quiz-cta');
  pills.forEach(function(p){
    p.addEventListener('click', function(){
      pills.forEach(function(x){ x.classList.remove('is-active'); });
      p.classList.add('is-active');
      if (heroCta) heroCta.classList.add('is-ready');
    });
  });
  var donut = document.querySelector('.vd-donut-fill');
  if (donut && 'IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) {
          var pct = parseFloat(donut.getAttribute('data-pct') || '88');
          var c = 2 * Math.PI * 90;
          donut.style.strokeDasharray = c;
          donut.style.strokeDashoffset = c * (1 - pct/100);
          obs.unobserve(donut);
        }
      });
    }, { threshold: .3 });
    obs.observe(donut);
  }
  var sticky = document.querySelector('.vd-sticky');
  var footer = document.querySelector('.vd-footer');
  if (sticky && footer) {
    var ioSticky = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        sticky.style.opacity = e.isIntersecting ? 0 : 1;
        sticky.style.pointerEvents = e.isIntersecting ? 'none' : 'auto';
      });
    }, { threshold: 0 });
    ioSticky.observe(footer);
    sticky.style.transition = 'opacity .3s';
  }
})();
